import { isSupportedLanguage, type SupportedLanguage } from './supportedLanguages'

const KEY = 'language'

export function getStoredLanguage(): SupportedLanguage | null {
  try {
    const raw = window.localStorage.getItem(KEY)
    return raw && isSupportedLanguage(raw) ? raw : null
  } catch {
    return null
  }
}

export function setStoredLanguage(lng: SupportedLanguage): void {
  try {
    window.localStorage.setItem(KEY, lng)
  } catch {
    // localStorage blocked — fall through silently
  }
}
